import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "442.845",
  height: "489.091",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "m43.7-24.297 196.27 353L196.27 353l-45.676-20.341L196.27 353l-45.676-20.341 106.11-238.274 51.09-114.725 91.352 40.68-51.09 114.726-146.837 329.728 40.727-91.453-40.727 91.453L-43.7 24.297z",
      style: {"fill":"#fff3e0","opacity":"1"},
      transform: "translate(43.7 24.297)"
    }, null, -1)
  ])))
}
export default { render: render }